import { render } from "./StackedBarChart.vue?vue&type=template&id=df13462e&scoped=true"
import script from "./StackedBarChart.vue?vue&type=script&lang=js"
export * from "./StackedBarChart.vue?vue&type=script&lang=js"

import "./StackedBarChart.vue?vue&type=style&index=0&id=df13462e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df13462e"]])

export default __exports__